import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GetWizardStatusRequest,
  GetWizardStatusResponse,
  ListWizardStatusRequest,
  ReplaceWizardStatusRequest,
  UserOnboardingApiService,
  WizardStatusInterface,
} from '@vendasta/partner';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserOnboardingService {
  constructor(private api: UserOnboardingApiService) {}

  getWizardStatus(partnerId: string, userId: string): Observable<GetWizardStatusResponse> {
    const request = new GetWizardStatusRequest({
      partnerId: partnerId,
      userId: userId,
    });
    return this.api.getWizardStatus(request).pipe(map((resp) => resp));
  }

  replaceWizardStatus(partnerId: string, userId: string, activeStep: string): Observable<boolean> {
    const request = new ReplaceWizardStatusRequest({
      partnerId: partnerId,
      userId: userId,
      activeStep: activeStep,
    });
    return this.api.replaceWizardStatus(request).pipe(map((response) => response.ok));
  }

  listWizardStatus(partnerId: string, pageSize?: number, cursor?: string): Observable<WizardStatusInterface[]> {
    const request = new ListWizardStatusRequest({
      partnerId: partnerId,
      paging: { pageSize: pageSize, cursor: cursor },
    });
    return this.api.listWizardStatus(request).pipe(map((response) => response.wizardStatuses));
  }
}
